import script from "./Our_viruchka.vue?vue&type=script&setup=true&lang=js"
export * from "./Our_viruchka.vue?vue&type=script&setup=true&lang=js"

import "./Our_viruchka.vue?vue&type=style&index=0&id=a67a684c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a67a684c"]])

export default __exports__